import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import * as OnboardingLayoutStyled from 'routes/components/OnboardingLayout/OnboardingLayout.styled'

export const Root = styled(Stack)({
  flex: 1,
  width: '100%',
  flexDirection: 'row',
  [`${OnboardingLayoutStyled.Root}`]: {
    flex: 2,
    background: 'white',
  },
  [`${OnboardingLayoutStyled.Paper}`]: {
    border: 'none',
  },
})
